<div class="home-container">

  <app-multi-tab [tabs]="tabs()" (activeTabChange)="onTabChange($event)"></app-multi-tab>

  <div class="bulletins-card">
    <div class="bulletins-header">
      <div class="dropdown">
        <div class="dropdown-toggle pointer bulletin-type-dropdown" data-toggle="dropdown">
          <div class="bulletins-title">{{activeBulletins}}</div>
          <i class="material-icons">expand_more</i>
        </div>
        <ul class="dropdown-menu">
          <li><a href="#" (click)='changeBulletinDisplay("sib")'>Service Bulletins</a></li>
          <li *ngIf="APP_SETTINGS.isExternal == 'false'"><a href="#" (click)='changeBulletinDisplay("pbs")'>Parts
              Bulletins</a>
          </li>
        </ul>
      </div>
      <div class="dropdown">
        <div class="bmw-home-sort pointer dropdown-toggle color" data-toggle="dropdown">
          <span>Sort</span>
          <i class="material-icons color">sort</i>
        </div>
        <ul class="dropdown-menu bmw-dropdown-background bmw-sort bmw-sm">
          <li>
            <a href="#" (click)='sortByProperty("releaseDate")'>
              <span class="bmw-dropdown-content">Sort by date</span>
            </a>
          </li>
          <li>
            <a href="#" (click)='sortByProperty("bulletinDisplayId")'>
              <span class="bmw-dropdown-content">Sort by bulletin #</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div>
      <div class="saved-bulletins-header">
        <span class="flex-20">Document Number</span>
        <span class="flex-60">Description</span>
        <span class="flex-20" style="text-align: right;">Release Date</span>
      </div>
      <div *ngFor='let bulletin of bulletins'>
        <a *ngIf='activeBulletins === "Service Bulletins"' [routerLink]="['/bulletin', bulletin?.bulletinDisplayId]"
          [queryParams]="{type: 'sib'}" class="bulletin-item">
          <div class="bulletin-info">
            <div class="bulletin-icon flex-20 align-center">
              <i class="material-icons">{{bulletin?.savedBulletinGroup ? 'star' :
                bulletin?.updatedBulletin ? 'new_releases' : 'fiber_new'}}
              </i>
              <span>{{bulletin?.bulletinDisplayNumber}}</span>
            </div>

            <span class="flex-60">{{bulletin?.description}}</span>
            <span class="flex-20" style="text-align: right;">{{bulletin?.releaseDate | date: 'yyyy-MM-dd'}}</span>
          </div>
        </a>
      </div>
    </div>
  </div>

  <div class="messages" *ngIf='messagesEnabled'>
    <span class="messages-title">Messages</span>
    <button class="toggle-btn" (click)="toggleMessages()">
      <div *ngIf="toggle">Hide <i class="material-icons">arrow_drop_up</i></div>
      <div *ngIf="!toggle">Show <i class="material-icons">arrow_drop_down</i></div>
    </button>
    <div *ngIf='toggle' class="messages-section">
      <div *ngIf="allMessages?.length === 0" class="no-messages">{{ noMessagesMessage }}</div>
      <div *ngIf="allMessages?.length > 0" class="messages-list">
        <div *ngFor='let message of allMessages' class="message-item">
          <div>{{message?.createdDate | date}}</div>
          <div class="message-desc">{{message?.description}}</div>
        </div>
      </div>
    </div>
  </div>
</div>